import { FunctionComponent } from "react";
import { PageId } from "../../../lib/types/ids";
import ProgressBarItem from "./ProgressBarItem";

type ProgressBarPage = {
  id: PageId;
  title: string;
};

type ProgressBarProps = {
  pages: Array<ProgressBarPage>;
  active: PageId | undefined;
  activeIndex: number;
  isPreview: boolean;
  setActivePage: (id: PageId) => void;
};

const ProgressBar: FunctionComponent<ProgressBarProps> = ({
  pages,
  active,
  activeIndex,
  isPreview,
  setActivePage,
}) => {
  const items = pages.map((page, index) => {
    const item = (
      <ProgressBarItem
        title={page.title}
        key={page.id}
        id={page.id}
        active={active}
        index={index}
        setActivePage={!isPreview && index > activeIndex ? () => null : setActivePage}
      />
    );

    return item;
  });
  return (
    <div>
      <div className=" border-gray-400 border-b my-8 lg:my-16 flex">
        {items}
      </div>
    </div>
  );
};

export default ProgressBar;
